import { FC, useState, useEffect } from "react";
import { Chip, Divider, Grid, MenuItem, Select, SelectChangeEvent, TextField, Typography } from "@mui/material";
import CustomSelect, { IOptions } from "../../FormFields/CustomSelect";
import CustomTextField from '../../FormFields/CustomTextField';
import { useAppSelector } from "../../../store/hooks";
import { fetchStates } from '../../../store/stateStore/stateThunk';

interface LegalProps {
  selected: any;
  methods: any;
  isEdit?: boolean;
}

// Legal component
const Legal: FC<LegalProps> = ({ selected, methods, isEdit }) => {
  const [countryOptions, setCountryOptions] = useState<IOptions[]>([]);
  const [country, setCountry] = useState('');
  const [stateOptions, setStateOptions] = useState<IOptions[]>([]);
  const [legalState, setLegalState] = useState('');
  const countriesList = useAppSelector(state => state.country.countries);
  const coutryStateList = useAppSelector(state => state.countryState.countryStates);

  useEffect(() => {
    console.log("debugging address data");
    console.log(selected);
    console.log(isEdit);
    console.log("debugging address data end");

    const setInitialData = () => {
      if (selected) {
        methods.setValue('registrationNo', selected?.registrationNo);

        // Handle both populated object and direct ObjectId string
        const countryId = typeof selected?.countryOfRegistration === 'string'
          ? selected?.countryOfRegistration
          : selected?.countryOfRegistration?._id || '';
        const stateId = typeof selected?.stateOfRegistration === 'string'
          ? selected?.stateOfRegistration
          : selected?.stateOfRegistration?._id || '';

        methods.setValue('countryOfRegistration', countryId);
        methods.setValue('stateOfRegistration', stateId);
        methods.setValue('taxIdentificationNumber1', selected?.taxIdentificationNumber1);
        methods.setValue('taxIdentificationNumber2', selected?.taxIdentificationNumber2);
        methods.setValue('openingBalanceAmount', selected?.openingBalance?.amount || '');
        methods.setValue('openingBalanceType', selected?.openingBalance?.balanceType || 'Dr');
        methods.setValue('openingBalanceDescription', selected?.openingBalance?.description || '');
        methods.setValue('openingBalanceReason', selected?.openingBalance?.reason || 'New books');
        methods.setValue('openingBalanceCustomReason', selected?.openingBalance?.customReason || '');
        setCountry(countryId);
        setLegalState(stateId);
      }
    }

    setInitialData();
    const countryOpts = countriesList.map((c: any) => {
      return { label: c.name, value: c._id }
    });
    setCountryOptions(countryOpts);
    // Auto-select first country on a new form, same as the address section does
    if (countryOpts.length >= 1 && !selected) {
      setCountry(countryOpts[0].value);
      methods.setValue('countryOfRegistration', countryOpts[0].value);
    }
    setStateOptions(coutryStateList.map((c: any) => {
      return { label: c.name, value: c._id }
    }));

  }, [selected, countriesList, methods]);

  return (
    <>
      {/* <Grid item xs={12}>
    <Typography variant="body1">{'Registration & Legal'}</Typography>
    </Grid> */}
      <Grid item xs={12} mt={1}>
        <Divider style={{ marginRight: -8 }}>
          <Chip label="Registration & Legal" size="small" />
        </Divider>
      </Grid>
      <Grid item xs={4}>
        <h5 className='c-label'>Company Registration Number</h5>
        <TextField
          placeholder='Registration Number'
          className='c-text-field'
          {...methods.register('registrationNo')}
          variant="standard"
          sx={{ width: '100%' }}
          required
          size='small'
          InputProps={{
            disableUnderline: true,
            readOnly: (selected && !isEdit) ? true : false
          }} />
        <p style={{ color: "#c33b3b" }}>{methods.formState.errors.registrationNo?.message ?? ""}</p>

      </Grid>
      <Grid item xs={4}>
        <h5 className='c-label'>State of Registration</h5>

        {stateOptions?.length > 0 &&
          <Select
            className='c-text-field'
            {...methods.register('stateOfRegistration')}
            disableUnderline
            required
            MenuProps={{
              PaperProps: {
                sx: {
                  border: "1.5px solid #e9ecf1",
                  // width: 255,
                  // marginLeft:'-29px !important',
                  boxShadow: 'none',
                  borderRadius: '5px'
                }
              }
            }}
            style={{ width: '100%' }}
            value={legalState ? legalState : ''}
            disabled={(selected && !isEdit) ? true : false}
            onChange={(event: SelectChangeEvent<any>) => {
              setLegalState(event.target.value);
            }}
            size='small'
            variant='outlined'
            sx={{
              boxShadow: "none",
              // fontSize:12,
              textAlign: 'right',
              '& .MuiOutlinedInput-input': { p: 0.5 },
              // '& .MuiSelect-select': { p:0 },
              marginBottom: '3px',
              ".MuiOutlinedInput-notchedOutline": { border: 0 },
              "&.MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline":
              {
                border: 0,
              },
              "&.MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline":
              {
                border: 0,
              },
            }}
          >
            {stateOptions && stateOptions.map((option) =>
              <MenuItem value={option.value} key={option.value}>{option.label}</MenuItem>
            )}
          </Select>}
        <p style={{ color: "#c33b3b" }}>{methods.formState.errors.stateOfRegistration?.message ?? ""}</p>
      </Grid>
      <Grid item xs={4}>
        <h5 className='c-label'>Country of registration</h5>
        {countryOptions?.length > 0 && <Select
          className='c-text-field'
          {...methods.register('countryOfRegistration')}
          disableUnderline
          required
          MenuProps={{
            PaperProps: {
              sx: {
                border: "1.5px solid #e9ecf1",
                // width: 255,
                // marginLeft:'-29px !important',
                boxShadow: 'none',
                borderRadius: '5px'
              }
            }
          }}
          style={{ width: '100%' }}
          value={country ? country : ''}
          disabled={(selected && !isEdit) ? true : false}
          onChange={(event: SelectChangeEvent<any>) => {
            setCountry(event.target.value);
            methods.setValue('countryOfRegistration', event.target.value);
          }}
          size='small'
          variant='outlined'
          sx={{
            boxShadow: "none",
            // fontSize:12,
            textAlign: 'right',
            '& .MuiOutlinedInput-input': { p: 0.5 },
            // '& .MuiSelect-select': { p:0 },
            marginBottom: '3px',
            ".MuiOutlinedInput-notchedOutline": { border: 0 },
            "&.MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline":
            {
              border: 0,
            },
            "&.MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline":
            {
              border: 0,
            },
          }}
        >
          {countryOptions && countryOptions.map((option) =>
            <MenuItem value={option.value} key={option.value}>{option.label}</MenuItem>
          )}
        </Select>}
        <p style={{ color: "#c33b3b" }}>{methods.formState.errors.countryOfRegistration?.message ?? ""}</p>
      </Grid>
      <Grid item xs={4}>
        <h5 className='c-label'>PAN Number</h5>
        <TextField
          placeholder='PAN Number'
          className='c-text-field'
          {...methods.register('taxIdentificationNumber1')}
          variant="standard"
          sx={{ width: '100%' }}
          required
          size='small'
          InputProps={{
            disableUnderline: true,
            readOnly: (selected && !isEdit) ? true : false
          }} />
        <p style={{ color: "#c33b3b" }}>{methods.formState.errors.taxIdentificationNumber1?.message ?? ""}</p>
      </Grid>
      <Grid item xs={4}>
        <h5 className='c-label'>GST Number</h5>
        <TextField
          placeholder='GST Number'
          className='c-text-field'
          {...methods.register('taxIdentificationNumber2')}
          variant="standard"
          sx={{ width: '100%' }}
          required
          size='small'
          InputProps={{
            disableUnderline: true,
            readOnly: (selected && !isEdit) ? true : false
          }} />
        <p style={{ color: "#c33b3b" }}>{methods.formState.errors.taxIdentificationNumber2?.message ?? ""}</p>
      </Grid>

      {/* Opening Balance Section */}
      <Grid item xs={12} mt={1}>
        <Divider style={{ marginRight: -8 }}>
          <Chip label="Opening Balance" size="small" />
        </Divider>
      </Grid>

      <Grid item xs={3}>
        <h5 className='c-label'>Opening Balance Amount</h5>
        <TextField
          placeholder='Opening Balance Amount'
          className='c-text-field'
          {...methods.register('openingBalanceAmount')}
          variant="standard"
          type='number'
          sx={{ width: '100%' }}
          size='small'
          InputProps={{
            disableUnderline: true,
            readOnly: (selected && !isEdit) ? true : false
          }} />
        <p style={{ color: "#c33b3b" }}>{methods.formState.errors.openingBalanceAmount?.message ?? ""}</p>
        {methods.watch('openingBalanceAmount') && Number(methods.watch('openingBalanceAmount')) > 0 && (
          <p style={{ fontSize: '11px', color: '#666', marginTop: '4px' }}>
            {methods.watch('openingBalanceType') === 'Dr'
              ? 'Party owes you (Receivable)'
              : 'You owe party (Payable)'}
          </p>
        )}
      </Grid>
      <Grid item xs={3}>
        <h5 className='c-label'>Balance Type</h5>
        <Select
          className='c-text-field'
          {...methods.register('openingBalanceType')}
          disableUnderline
          MenuProps={{
            PaperProps: {
              sx: {
                border: "1.5px solid #e9ecf1",
                boxShadow: 'none',
                borderRadius: '5px'
              }
            }
          }}
          style={{ width: '100%' }}
          value={methods.watch('openingBalanceType') || 'Dr'}
          disabled={(selected && !isEdit) ? true : false}
          onChange={(event: SelectChangeEvent<any>) => {
            methods.setValue('openingBalanceType', event.target.value);
          }}
          size='small'
          variant='outlined'
          sx={{
            boxShadow: "none",
            textAlign: 'right',
            '& .MuiOutlinedInput-input': { p: 0.5 },
            marginBottom: '3px',
            ".MuiOutlinedInput-notchedOutline": { border: 0 },
            "&.MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline":
            {
              border: 0,
            },
            "&.MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline":
            {
              border: 0,
            },
          }}
        >
          <MenuItem value="Dr">Debit (Dr)</MenuItem>
          <MenuItem value="Cr">Credit (Cr)</MenuItem>
        </Select>
        <p style={{ color: "#c33b3b" }}>{methods.formState.errors.openingBalanceType?.message ?? ""}</p>
      </Grid>
      <Grid item xs={3}>
        <h5 className='c-label'>Opening Balance Description</h5>
        <TextField
          placeholder='Opening Balance Description'
          className='c-text-field'
          {...methods.register('openingBalanceDescription')}
          variant="standard"
          sx={{ width: '100%' }}
          size='small'
          InputProps={{
            disableUnderline: true,
            readOnly: (selected && !isEdit) ? true : false
          }} />
        <p style={{ color: "#c33b3b" }}>{methods.formState.errors.openingBalanceDescription?.message ?? ""}</p>
      </Grid>
      <Grid item xs={3}>
        <h5 className='c-label'>Opening Balance Reason</h5>
        <Select
          className='c-text-field'
          {...methods.register('openingBalanceReason')}
          disableUnderline
          MenuProps={{
            PaperProps: {
              sx: {
                border: "1.5px solid #e9ecf1",
                boxShadow: 'none',
                borderRadius: '5px'
              }
            }
          }}
          style={{ width: '100%' }}
          value={methods.watch('openingBalanceReason') || 'New books'}
          disabled={(selected && !isEdit) ? true : false}
          onChange={(event: SelectChangeEvent<any>) => {
            methods.setValue('openingBalanceReason', event.target.value);
          }}
          size='small'
          variant='outlined'
          sx={{
            boxShadow: "none",
            textAlign: 'right',
            '& .MuiOutlinedInput-input': { p: 0.5 },
            marginBottom: '3px',
            ".MuiOutlinedInput-notchedOutline": { border: 0 },
            "&.MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline":
            {
              border: 0,
            },
            "&.MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline":
            {
              border: 0,
            },
          }}
        >
          <MenuItem value="New books">New Books</MenuItem>
          <MenuItem value="Previous year">Previous Year</MenuItem>
          <MenuItem value="Audited">Audited</MenuItem>
          <MenuItem value="Books were lost">Books Were Lost</MenuItem>
          <MenuItem value="Data corruption">Data Corruption</MenuItem>
          <MenuItem value="Past records unavailable">Past Records Unavailable</MenuItem>
          <MenuItem value="Custom">Custom</MenuItem>
        </Select>
        <p style={{ color: "#c33b3b" }}>{methods.formState.errors.openingBalanceReason?.message ?? ""}</p>
      </Grid>
      {methods.watch('openingBalanceReason') === 'Custom' && (
        <Grid item xs={6} mb={4}>
          <h5 className='c-label'>Custom Reason</h5>
          <TextField
            placeholder='Enter custom reason'
            className='c-text-field'
            {...methods.register('openingBalanceCustomReason')}
            variant="standard"
            sx={{ width: '100%' }}
            size='small'
            InputProps={{
              disableUnderline: true,
              readOnly: (selected && !isEdit) ? true : false
            }} />
          <p style={{ color: "#c33b3b" }}>{methods.formState.errors.openingBalanceCustomReason?.message ?? ""}</p>
        </Grid>
      )}
    </>
  );
};

export default Legal;
